import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/dreamsLogo.png";
import { useSelector } from "react-redux";

const Logo = (props) => {
  const avatar_url = useSelector(
    (state) => state.organization.details.avatar_url
  );

  return (
    <Link to={`/`} style={{ display: "flex" }}>
      <img
        src={avatar_url ? avatar_url : logo}
        alt={"logo"}
        style={{ height: "40px" }}
      />
    </Link>
  );
};

export default Logo;
